//@flow
import React from 'react';
import { Link } from 'react-router';

import type CategoryModel from '../../Stores/MemberCategories/categoryModel';

type Props = {
  category:CategoryModel,
  className:string,
  isOffice?:boolean,
};

export default function CategoryThumbnail(props:Props) {
  const imageSrc = props.category.getThumbnailSliderImageUrl();
  const name = props.category.getName();
  const url = props.isOffice
    ? `/office/catalog/products/${props.category.getUrlKey()}#category-content`
    : `/products/${props.category.getUrlKey()}#category-content`;

  return (
    <Link to={url}>
      <div className={props.className}>
        <div className="thumbnail-image-holder">
          <img src={imageSrc} alt={name}></img>
        </div>
        <div className="category-name">{name}</div>
      </div>
    </Link>
  );
}
